var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgForwardToInboxFill = function SvgForwardToInboxFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "forward_to_inbox_fill_svg__a",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h40v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#forward_to_inbox_fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#583EEE",
    d: "M32.633 32.5h-6.286a1.2 1.2 0 0 1-.89-.36 1.2 1.2 0 0 1-.36-.89q0-.533.36-.891.359-.36.89-.359h6.302l-2.205-2.205a1.18 1.18 0 0 1-.367-.878q.005-.506.392-.879.372-.345.878-.35t.879.366l4.14 4.142q.234.233.344.493.108.26.108.56a1.45 1.45 0 0 1-.451 1.055l-4.157 4.157q-.346.347-.858.351a1.2 1.2 0 0 1-.883-.367 1.17 1.17 0 0 1-.346-.862q0-.516.346-.862zm-25.452 0a2.9 2.9 0 0 1-2.13-.883 2.9 2.9 0 0 1-.883-2.13V10.513q0-1.247.883-2.13a2.9 2.9 0 0 1 2.13-.883h25.64q1.248 0 2.13.883.885.883.884 2.13v10.769q0 .685-.566 1.063-.566.376-1.226.133a12 12 0 0 0-1.303-.286 8.4 8.4 0 0 0-1.345-.109q-3.877 0-6.594 2.717-2.715 2.716-2.716 6.594 0 .468-.32.787a1.07 1.07 0 0 1-.786.319zM20 18.333l-11.567-7.4q-.516-.33-1.053-.058t-.585.865q-.048.31.07.6a.98.98 0 0 0 .404.464l11.92 7.616q.385.234.811.234t.811-.234l11.92-7.616q.285-.176.412-.464a.97.97 0 0 0 .062-.6.99.99 0 0 0-.585-.857q-.536-.264-1.052.066z"
  }))));
};
export default SvgForwardToInboxFill;